import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { TransPipe } from '../../../shared/pipes/trans.pipe';
import { CalendarDataService } from '../../../shared/services/calendar/calendar-data.service';
import { CalendarService } from '../../../shared/services/calendar/calendar.service';
import { DropdownModule } from './../dropdown/dropdown.module';
import { AccordionCommentCalendarComponent } from './accordion-comment-calendar/accordion-comment-calendar.component';
import { CalendarBasicComponent } from './calendar-basic/calendar-basic.component';
import { PlanningReminderComponent } from './planning-reminder/planning-reminder.component';
import { PlanningComponent } from './planning/planning.component';

@NgModule({
  declarations: [
    CalendarBasicComponent,
    AccordionCommentCalendarComponent,
    PlanningComponent,
    PlanningReminderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    DropdownModule,
    PipesModule,
    FullCalendarModule
  ],
  exports: [
    CalendarBasicComponent, AccordionCommentCalendarComponent, NgbAccordionModule, PlanningComponent, PlanningReminderComponent,
  ],
  providers: [CalendarService, CalendarDataService, TransPipe]
})
export class CalendarWrapperModule { }
